import React, { useState, useEffect } from 'react';

const LoadingScreen = () => {
  const [progress, setProgress] = useState(0);
  const [showContent, setShowContent] = useState(false);
  
  useEffect(() => {
    // Fade in content immediately
    setShowContent(true);
    
    // Animate progress bar quickly
    const progressTimer = setInterval(() => {
      setProgress(prev => {
        const newProgress = prev + 10;
        return newProgress > 100 ? 100 : newProgress;
      });
    }, 50);
    
    return () => {
      clearInterval(progressTimer);
    };
  }, []);
  
  return (
    <div className="fixed inset-0 bg-black flex items-center justify-center z-50">
      <div className={`transition-all duration-300 transform ${showContent ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}`}>
        <div className="relative w-48 sm:w-56 flex flex-col items-center">
          {/* Logo Image - Increased size */}
          <div className="relative w-24 h-24 sm:w-28 sm:h-28 mb-4">
            <div className={`absolute inset-0 bg-ta-green/20 rounded-full transition-transform duration-1000 ${progress < 100 ? 'animate-pulse' : ''}`}></div>
            <img 
              src="https://imgur.com/1HmKGnQ.jpg"
              alt="TravelCord Logo"
              className="w-full h-full object-cover rounded-full border-2 border-ta-green shadow-lg"
              width="112"
              height="112"
            />
          </div>
          
          {/* Progress Bar */}
          <div className="w-full h-0.5 bg-white/10 rounded-full overflow-hidden mb-3">
            <div 
              className="h-full bg-ta-green rounded-full transition-all duration-300 ease-out"
              style={{ width: `${progress}%` }}
            ></div>
          </div>
          
          {/* Main Text */}
          <p className="text-white/90 text-sm sm:text-base font-medium text-center mb-1">
            Explore Uganda with Local Experts
          </p>
          
          {/* Status Text */}
          <p className="text-white/40 text-[10px] tracking-wider font-light">
            {progress < 100 ? 'PREPARING YOUR JOURNEY' : 'READY TO EXPLORE'}
          </p>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;